import { Observable } from 'rxjs';
import { ExtractionSample } from '../../model/extraction-sample/extraction-sample.model';
import { ExtractionSampleQueryParams } from '../../model/extraction-sample/extraction-sample-query-params.model';
import { PaginatedResponse } from '../../model/common/pagination.model';

/**
 * Abstract repository for Extraction Samples
 * Defines the contract for data access operations
 * HU21-941147: Listar Órdenes por Extraer
 * HU22-920838: Imprimir Etiqueta de Contenedores
 *
 * This follows the Repository Pattern from Clean Architecture
 * - Domain layer defines the interface (this file)
 * - Infrastructure layer implements it (HttpExtractionSampleRepository)
 */
export abstract class ExtractionSampleRepository {
  /**
   * Get paginated list of extraction samples
   * @param params Query parameters for filtering, sorting, and pagination
   * @returns Observable with paginated samples
   */
  abstract findAll(
    params?: ExtractionSampleQueryParams
  ): Observable<PaginatedResponse<ExtractionSample>>;

  /**
   * Export extraction samples to CSV
   * @param params Query parameters for filtering, sorting
   * @returns Observable with Blob containing the CSV file
   */
  abstract exportToCSV(params?: ExtractionSampleQueryParams): Observable<Blob>;

  /**
   * Print labels for selected specimen IDs
   * Downloads a PDF file with labels for the specimens
   * @param specimenIds Array of specimen UUIDs to print labels for
   * @returns Observable with PDF blob
   */
  abstract printLabels(specimenIds: string[]): Observable<Blob>;
}
